$(document).ready(function () {
  $('a').on('click', function (event) {
    if (this.hash !== '') {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top,
      }, 400, function () {

        window.location.hash = hash;
      });
    } // End if
  });
});

$(document).ready(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 600) {
      $('#header').addClass('fixed');
      $('body').addClass('scroll');
    } else if ($(this).scrollTop() <= 600) {
      $('#header').removeClass('fixed');
      $('body').removeClass('scroll');
    }
  });
  $(window).scroll();
});
